module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/jacek-czlonkowski-6887d19ebe2e46a1dc0147adf59fbb81.png";